import {createAsyncThunk} from '@reduxjs/toolkit';

import type {Team} from '@mattermost/types/teams';
import type {User} from 'features/users';

import type {AppDispatch} from 'stores/redux_store';

import {startFollowingThread} from '../api/start_following_thread';

import {stopFollowingThread} from '../api/stop_following_thread';

import type {ClientThread} from '../types/extended';

import {reportMessageToSentry} from 'utils/sentry';

import {getSelectedThreadId} from '../selectors/get_selected_thread_id';
import type {GlobalState} from 'types/store';

import {changeThreadFollow} from './change_thread_follow';

type Payload = {
    userId: User['id'];
    teamId: Team['id'];
    threadId: ClientThread['id'];
    following: boolean;
};

export const changeThreadFollowOnServer = createAsyncThunk(
    'threads/actions/changeThreadFollowOnServer',
    async (payload: Payload, thunkAPI) => {
        const dispatch = thunkAPI.dispatch as AppDispatch;
        const {following, teamId, threadId, userId} = payload;

        try {
            if (following) {
                await dispatch(
                    startFollowingThread({
                        teamId,
                        threadId,
                        userId,
                    }),
                ).unwrap();
            } else {
                await dispatch(
                    stopFollowingThread({
                        teamId,
                        threadId,
                        userId,
                    }),
                ).unwrap();
            }

            const state = thunkAPI.getState() as GlobalState;

            const selectedThreadId = getSelectedThreadId(state);

            dispatch(
                changeThreadFollow({
                    following,
                    threadId,
                    selectedThreadId,
                }),
            );
            // eslint-disable-next-line no-empty
        } catch (e: any) {
            reportMessageToSentry(`Encountered error while changeThreadFollowOnServer "${e.message}"`);
        }
    },
);
